var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "department-picker-inline" }, [
    _c("div", { staticClass: "pr-search" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchText,
            expression: "searchText",
          },
        ],
        attrs: { placeholder: "Search Department" },
        domProps: { value: _vm.searchText },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchText = $event.target.value
            },
            _vm.searchChange,
          ],
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons mx-2 pr-icon" }, [
        _vm._v(" search "),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pr-items pr-item-wrapper" },
      _vm._l(_vm.getFilteredItems(), function (item) {
        return _c(
          "div",
          {
            staticClass: "pr-item",
            on: {
              click: function (e) {
                return _vm.toggleDepartment(e, item._id)
              },
            },
          },
          [
            _c("a-checkbox", {
              staticClass: "segment-checkbox",
              attrs: { checked: _vm.selectedIds.includes(item._id) },
              on: {
                click: function (e) {
                  return _vm.toggleDepartment(e, item._id)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "item-data-wrapper" }, [
              _c(
                "div",
                { staticClass: "item-data" },
                [
                  _c("Avatar", {
                    staticClass: "mr-2 avatar",
                    attrs: { size: 30, username: _vm.getDepartmentName(item) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "metas" }, [
                    _c("div", { staticClass: "pr-item-name" }, [
                      _vm._v(_vm._s(_vm.getDepartmentName(item))),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }